<template>
  <div class="l-container FamilysupportsIndex">
    <span style="margin-top: 10px; display: inline-block">現在表示数 : {{max}} </span>
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">id</template>
      <template v-if="this.sortColumn === 'company_id'">会社名</template>
      <template v-if="this.sortColumn === 'office_id'">営業所</template>
      <template v-if="this.sortColumn === 'family_id'">家庭id</template>
      <template v-if="this.sortColumn === 'name'">名前</template>
      <template v-if="this.sortColumn === 'kana'">かな</template>
      <template v-if="this.sortColumn === 'address'">住所</template>
      <template v-if="this.sortColumn === 'user_id'">登録者</template>
      <template v-if="this.sortColumn === 'support_date'">対応日</template>
      <template v-if="this.sortColumn === 'tag_id'">タグ</template>
      <template v-if="this.sortColumn === 'note'">対応内容</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
      <template v-if="this.sortColumn === 'updated_at'">更新日</template>
       : {{sortState}}
    </span>
    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">id</btn>
        <btn class="m-btn--column" @click.native="switchV('company_id')" v-bind:class="{ 'active': company_id }">会社名</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('family_id')" v-bind:class="{ 'active': family_id }">家庭id</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('support_date')" v-bind:class="{ 'active': support_date }">対応日</btn>
        <btn class="m-btn--column" @click.native="switchV('support_date')" v-bind:class="{ 'active': support_date }">~対応日</btn>
        <btn class="m-btn--column" @click.native="switchV('tag_id')" v-bind:class="{ 'active': tag_id }">タグ</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">対応内容</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">更新日</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="company_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.company_id" :options="companies" label="name" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="family_id"><td-c class="sticky-1"><input v-model="search.family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="filteredUsers" label="user" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="support_date"><td-c class="sticky-1"><input v-model="search.support_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="support_date"><td-c class="sticky-1"><input v-model="search.support_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tag_id">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.tag_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="tags" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c class="sticky-1"><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="company_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_company_id" :options="companies" label="name" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="family_id"><td-c class="sticky-2"><input v-model="search.not_family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="filteredUsers" label="user" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="support_date"><td-c class="sticky-2"><input v-model="search.not_support_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="support_date"><td-c class="sticky-2"><input v-model="search.not_support_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tag_id">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_tag_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="tags" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c class="sticky-2"><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c class="sticky-3" @click.native='sort("id")'>id</th-c></template>
          <template v-if="company_id"><th-c class="sticky-3" @click.native='sort("company_id")'>会社名</th-c></template>
          <template v-if="office_id"><th-c class="sticky-3" @click.native='sort("office_id")'>営業所</th-c></template>
          <template v-if="family_id"><th-c class="sticky-3" @click.native='sort("family_id")'>家庭id</th-c></template>
          <template v-if="name"><th-c class="sticky-3" @click.native='sort("name")'>名前</th-c></template>
          <template v-if="kana"><th-c class="sticky-3" @click.native='sort("kana")'>かな</th-c></template>
          <template v-if="address"><th-c class="sticky-3" @click.native='sort("address")'>住所</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3" @click.native='sort("user_id")'>登録者</th-c></template>
          <template v-if="support_date"><th-c class="sticky-3" @click.native='sort("support_date")'>対応日</th-c></template>
          <template v-if="support_date"><th-c class="sticky-3" @click.native='sort("support_date")'>~対応日</th-c></template>
          <template v-if="tag_id"><th-c class="sticky-3" @click.native='sort("tag_id")'>タグ</th-c></template>
          <template v-if="note"><th-c class="sticky-3" @click.native='sort("note")'>対応内容</th-c></template>
          <template v-if="created_at"><th-c class="sticky-3" @click.native='sort("created_at")'>作成日</th-c></template>
          <template v-if="updated_at"><th-c class="sticky-3" @click.native='sort("updated_at")'>更新日</th-c></template>
        </tr-c>

        <tr-c @click.native='linkFamily(list)' slot="tr-td" v-for="(list, index) in mapFamilysupports" :key="index.id" class="tr_hover">
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="company_id">
            <template v-if="list.family">
              <td-c>{{list.company}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="office_id">
            <td-c v-if="list.office_id === 0">未選択</td-c>
            <td-c v-if="list.office_id === 1">仙台</td-c>
            <td-c v-if="list.office_id === 2">札幌</td-c>
            <td-c v-if="list.office_id === 3">名古屋</td-c>
            <td-c v-if="list.office_id === 4">福岡</td-c>
            <td-c v-if="list.office_id === 5">新宿</td-c>
            <td-c v-if="list.office_id === 6">大宮</td-c>
            <td-c v-if="list.office_id === 7">高松</td-c>
            <td-c v-if="list.office_id === 8">高崎</td-c>
            <td-c v-if="list.office_id === 9">東京</td-c>
            <td-c v-if="list.office_id === 10">大阪</td-c>
          </template>
          <template v-if="family_id"><td-c>{{list.family_id}}</td-c></template>
          <template v-if="name">
            <template v-if="list.family">
              <td-c>{{list.family.f_name}} {{list.family.l_name}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="kana">
            <template v-if="list.family">
              <td-c>{{list.family.f_name_kana}} {{list.family.l_name_kana}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="address">
            <template v-if="list.family">
              <td-c>{{list.family.address1}} {{list.family.address2}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="user_id">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="support_date"><td-c>{{list.support_date.substring(0, 10)}}</td-c></template>
          <template v-if="support_date"><td-c></td-c></template>

          <template v-if="tag_id">
            <template v-if="list.support_tags.length > 0">
              <td-c>
                <span
                  v-for="(list, index) in list.support_tags"
                  :key="index"
                  v-bind:style="{ 'backgroundColor': list.tag.color }"
                  style="color: #fff; padding: 5px; border-radius: 5px; margin: 2px; display: inline-block">
                  {{list.tag.name}}
                </span>
              </td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="note"><td-c v-html="list.note"></td-c></template>
          <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/familysupports/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'familysupport',
  pageNames: 'familysupports'
}

let _ = window._
export default {
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: false,
      company_id: true,
      office_id: true,
      family_id: false,
      name: true,
      kana: true,
      address: true,
      user_id: true,
      support_date: true,
      tag_id: true,
      note: true,
      created_at: true,
      updated_at: true,

      search: {
        id: '',
        company_id: '',
        office_id: '',
        family_id: '',
        name: '',
        kana: '',
        address: '',
        user_id: '',
        support_date: [],
        tag_id: '',
        note: '',
        created_at: '',
        updated_at: '',

        not_id: '',
        not_company_id: '',
        not_office_id: '',
        not_family_id: '',
        not_name: '',
        not_kana: '',
        not_address: '',
        not_user_id: '',
        not_support_date: [],
        not_tag_id: '',
        not_note: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
        company_id: '',
        office_id: '',
        user_id: '',
        tag_id: [],

        not_company_id: '',
        not_office_id: '',
        not_user_id: '',
        not_tag_id: []
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    familysupports () {
      return this.$store.getters.familysupports
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    filteredUsers () {
      let self = this
      if (self.user.office_id === 1) {
        return self.users.filter((user) => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.users.filter((user) => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.users.filter((user) => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.users.filter((user) => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.users.filter((user) => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.users.filter((user) => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.users.filter((user) => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.users.filter((user) => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.users.filter((user) => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.users.filter((user) => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.users.filter((user) => {
          return user.hide_flag !== 1
        })
      }
    },

    tags () {
      return this.$store.getters.tags
    },

    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    orderedFamilysupports () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.familysupports, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.familysupports, this.sortColumn)
      }
    },

    mapFamilysupports () {
      let self = this
      return self.orderedFamilysupports.map((familysupport) => {
        if (familysupport.family) {
          if (familysupport.family.company_id) {
            familysupport.company = self.calcCompany(familysupport.family.company_id)
          }
        }
        return familysupport
      })
    }
  },
  watch: {
    'watch.tag_id': function (now, old) {
      if (now) {
        this.search.tag_id = ''
        for (let i = 0; i < now.length; i++) {
          this.search.tag_id += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_tag_id': function (now, old) {
      if (now) {
        this.search.not_tag_id = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_tag_id += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.company_id': function (now, old) {
      if (now) {
        this.search.company_id = now.id
      } else {
        this.search.company_id = ''
      }
    },

    'watch.not_company_id': function (now, old) {
      if (now) {
        this.search.not_company_id = now.id
      } else {
        this.search.not_company_id = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    }
  },
  methods: {
    calcCompany (val) {
      if (val) {
        return this.companies.filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    linkFamily (familysupport) {
      this.$router.push({name: 'familyindex', params: { id: familysupport.family_id }})
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.company_id = false
      this.office_id = false
      this.family_id = false
      this.name = false
      this.kana = false
      this.address = false
      this.user_id = false
      this.support_date = false
      this.tag_id = false
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.id = true
      this.company_id = true
      this.office_id = true
      this.family_id = true
      this.name = true
      this.kana = true
      this.address = true
      this.user_id = true
      this.support_date = true
      this.tag_id = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    def () {
      this.id = false
      this.company_id = true
      this.office_id = true
      this.family_id = false
      this.name = true
      this.kana = true
      this.address = true
      this.user_id = true
      this.support_date = true
      this.tag_id = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.company_id = 0
      this.watch.office_id = 0
      this.search.family_id = ''
      this.search.name = ''
      this.search.kana = ''
      this.search.address = ''
      this.watch.user_id = 0
      this.search.support_date = []
      this.watch.tag_id = []
      this.search.note = ''
      this.search.created_at = ''
      this.search.updated_at = ''

      this.search.not_id = ''
      this.watch.not_company_id = 0
      this.watch.not_office_id = 0
      this.search.not_family_id = ''
      this.search.not_name = ''
      this.search.not_kana = ''
      this.search.not_address = ''
      this.watch.not_user_id = 0
      this.search.not_support_date = []
      this.watch.not_tag_id = []
      this.search.not_note = ''
      this.search.not_created_at = ''
      this.search.not_updated_at = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('familysupportsSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.company_id = obj['company_id']
      vm.watch.office_id = obj['office_id']
      vm.search.family_id = obj['family_id']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.search.address = obj['address']
      vm.watch.user_id = obj['user_id']
      vm.search.note = obj['note']
      vm.search.support_date = obj['support_date']
      vm.watch.tag_id = obj['tag_id']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']

      vm.search.not_id = obj['not_id']
      vm.watch.not_company_id = obj['not_company_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.search.not_family_id = obj['not_family_id']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.search.not_address = obj['not_address']
      vm.watch.not_user_id = obj['not_user_id']
      vm.search.not_note = obj['not_note']
      vm.search.not_support_date = obj['not_support_date']
      vm.watch.not_tag_id = obj['not_tag_id']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']

      vm.id = obj['column_id']
      vm.company_id = obj['column_company_id']
      vm.office_id = obj['column_office_id']
      vm.family_id = obj['column_family_id']
      vm.name = obj['column_name']
      vm.kana = obj['column_kana']
      vm.address = obj['column_address']
      vm.user_id = obj['column_user_id']
      vm.note = obj['column_note']
      vm.support_date = obj['column_support_date']
      vm.tag_id = obj['column_tag_id']
      vm.created_at = obj['column_created_at']
      vm.updated_at = obj['column_updated_at']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      company_id: this.watch.company_id,
      office_id: this.watch.office_id,
      family_id: this.search.family_id,
      name: this.search.name,
      kana: this.search.kana,
      address: this.search.address,
      user_id: this.watch.user_id,
      note: this.search.note,
      support_date: this.search.support_date,
      tag_id: this.watch.tag_id,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,

      not_company_id: this.watch.not_company_id,
      not_office_id: this.watch.not_office_id,
      not_family_id: this.search.not_family_id,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_address: this.search.not_address,
      not_user_id: this.watch.not_user_id,
      not_note: this.search.not_note,
      not_support_date: this.search.not_support_date,
      not_tag_id: this.watch.not_tag_id,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at,

      column_id: this.id,
      column_company_id: this.company_id,
      column_office_id: this.office_id,
      column_family_id: this.family_id,
      column_name: this.name,
      column_kana: this.kana,
      column_address: this.address,
      column_user_id: this.user_id,
      column_note: this.note,
      column_support_date: this.support_date,
      column_tag_id: this.tag_id,
      column_created_at: this.created_at,
      column_updated_at: this.updated_at
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('familysupportsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 200px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f015";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>

<style lang="scss">
.FamilysupportsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// FamilysupportsIndex.vue?22dfec74